import AOS from "aos"

import "aos/dist/aos.css"

export default defineNuxtPlugin((nuxtApp) => {
        if (typeof window !== 'undefined') {
                window.AOS = AOS
        }
})
